var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// React
import React from "react";
import { connect } from "react-redux";
import * as appRouting from "appRouting";
// Components
import CardPanel from "common/ui/components/nav/cardPanel/CardPanel";
import Card from "common/ui/components/nav/cardPanel/Card";
// Helpers
import NamingHelper from "common/utils/namingHelper";
const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});
//-- Component -------------------------------------------------------------------------------------------------------------------------------
let AgencyReportsOptions = class AgencyReportsOptions extends React.Component {
    render() {
        let agencyId = this.props.agencyId;
        return (React.createElement(CardPanel, { title: "Reports", titleColour: "#669548" },
            React.createElement(Card, { url: appRouting.agencyStatsReportUrl(agencyId), label: NamingHelper.agencyOverview, description: "See a summary of each of your branches listing counts, views and leads." })));
    }
};
AgencyReportsOptions = __decorate([
    connect(mapStateToProps, mapDispatchToProps)
], AgencyReportsOptions);
export default AgencyReportsOptions;
